<template>
    <section class="hero-clinic bg-cover" id="home">
        <div class="clinic-hero-wrapper">
            <div class="container">
                <div class="row">
                    <div class="col-lg-10 ml-auto mr-auto">
                        <div class="clinic-hero-title text-center section-space--mb_50">
                            <h1 class="heading mb-10">{{ $t('destekmiistiyorsunuz') }}</h1> 
                            <div class="sub-text">{{$t('slogan7')}}</div>
                            <div class="sub-text"> <i class="fa fa-phone-office"></i><a href="tel:+905322412008" class="hover-style-link"> +90 532 241 20 08</a></div>
                        </div>
                        <div class="ht-contact-hero-box">
                            <div class="ht-contact-hero-box--inner">
                                <form v-on:submit="gonderMail" class="ht-contact-hero-box--clinic">
                                    <div class="clinic-form-item">
                                        <div class="form-icon"><i class="fal fa-user-alt"></i></div>
                                        <input type="text" v-model="ContactForm.name" :placeholder="$t('adiniz')">
                                    </div>
                                    <div class="clinic-form-item">
                                        <div class="form-icon"><i class="fal fa-phone"></i></div>
                                        <input type="tel" id="phone" name="phone" pattern="[0-9]{10}" title="(111)111-11-11" maxlength="10" required v-model="ContactForm.email" :placeholder="$t('telefonnumaraniz')">
                                        <input name="subject_html" v-model="ContactForm.subject" :placeholder="$t('email')" hidden>
                                        <input name="message_html" v-model="ContactForm.message" :placeholder="$t('email')" hidden>
                                    </div>
                                    <div class="clinic-form-item form-submit">
                                        <div class="clinic-button">
                                            <button type="submit" class="ht-btn ht-btn-md">{{$t('bizarayalim')}}</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="clinic-hero-bottom section-space--pt_90">
                <div class="vc_row-separator big_triangle_alt bottom">
                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="none" viewBox="0 0 100 100">
                        <polygon points="0,0 50,100 100,0 101,100 0 101"></polygon>
                    </svg>
                </div>
                <div class="clinic-hero-image">
                    <img src="../../assets/img/hero/clinic/aeroland-clinic-hero-image.png" class="img-fluid" alt="clinic hero thumbnail">
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import axios from 'axios';
import qs from 'qs';
import xml2js from "xml2js";
import fs from "fs";
import notify from 'devextreme/ui/notify';
import { mapGetters } from "vuex";
export default {
        data() {
        return {
            sModuller:'',
            sOnayKodlari:'',
            sent: false,
              ContactForm: {
                name : '',
                email: '',
                phone: '',
                subject: 'Beni Arayın',
                message: 'Beni Arayın'
              }
            }
        },
        computed:{
            ...mapGetters("auth", ["getFirmaResult"])
        },    
        methods:{
            gonderMail(){
                //console.log(event);
                //console.log(this.ContactForm);
                //console.log(this);
                //console.log(event);
                //console.log(event.target.childNodes);
                //console.log(event.srcElement.childNodes[1]._value);
                
                event.preventDefault()
                //debugger;
                var str="<?xml version='1.0' encoding='utf-8'?>"+
                      "<soap12:Envelope xmlns:xsi='http://www.w3.org/2001/XMLSchema-instance' xmlns:xsd='http://www.w3.org/2001/XMLSchema' xmlns:soap12='http://www.w3.org/2003/05/soap-envelope'>"+
                      "<soap12:Header>" +
                      "<SecuredTokenWebservice xmlns='http://tempuri.org/'>"+
                      "<sMail>"+this.getFirmaResult.sMail+"</sMail>"+
                      "<sUserName>"+this.getFirmaResult.nFirmaID+"</sUserName>"+
                      "<sPassword>"+this.getFirmaResult.sPostaKodu+"</sPassword>"+
                      "<AuthenticationToken>string</AuthenticationToken>"+
                      "<sBayii>"+this.getFirmaResult.nFirmaID+"</sBayii>"+
                      "</SecuredTokenWebservice>"+
                      "</soap12:Header>"+
                      "<soap12:Body>"+
                      "<AuthenticationUser xmlns='http://tempuri.org/' />"+
                      "</soap12:Body>"+
                      "</soap12:Envelope>";
                      
                      axios({method:'post',url:'https://www.barkodyazilimevi.com.tr/AuthToken.asmx',data:str,headers: {'Content-Type': 'text/xml','Access-Control-Allow-Headers': 'Origin'}})
                      .then((response) => {
                        //console.log(response);
                        var parseString = require('xml2js').parseString;
                        var xml = response.data
                        var AuthenticationToken =""
                        parseString(xml, function (err, result) {
                          //console.log(result["soap:Envelope"]["soap:Body"][0].AuthenticationUserResponse[0].AuthenticationUserResult[0]);
                          AuthenticationToken = result["soap:Envelope"]["soap:Body"][0].AuthenticationUserResponse[0].AuthenticationUserResult[0];
                        });
                      var sFirma = "<p><strong><u>" + this.ContactForm.message + ";</u></strong><br>" + "Adım:<strong>" + this.ContactForm.name  + "</strong><br>"+"Telefon Numaram:<strong>" + this.ContactForm.email + "</strong></p>";
                      //console.log(sFirma);
                      var ip=window.location.host; 
                      axios('https://api.ipify.org?format=json')
                        .then(response => {
                            ip=response.data.ip
                            console.log(ip);
                        
                      var str2="<?xml version='1.0' encoding='utf-8'?>"+
                      "<soap12:Envelope xmlns:xsi='http://www.w3.org/2001/XMLSchema-instance' xmlns:xsd='http://www.w3.org/2001/XMLSchema' xmlns:soap12='http://www.w3.org/2003/05/soap-envelope'>"+
                      "<soap12:Header>" +
                      "<SecuredTokenWebservice xmlns='http://tempuri.org/'>"+
                      "<sMail>"+this.getFirmaResult.sMail+"</sMail>"+
                      "<sUserName>"+this.getFirmaResult.nFirmaID+"</sUserName>"+
                      "<sPassword>"+this.getFirmaResult.sPostaKodu+"</sPassword>"+
                      "<AuthenticationToken>"+AuthenticationToken+"</AuthenticationToken>"+
                      "<sBayii>"+this.getFirmaResult.nFirmaID+"</sBayii>"+
                      "</SecuredTokenWebservice>"+
                      "</soap12:Header>"+
                      "<soap12:Body>"+
                      "<mail_gonder xmlns='http://tempuri.org/'>"+
                      "<sSubject>"+this.ContactForm.subject+"</sSubject>"+
                      "<nFirmaID>"+this.getFirmaResult.nFirmaID+"</nFirmaID>"+
                      "<sKodu></sKodu>"+
                      "<sAciklama></sAciklama>"+
                      "<sAdres1></sAdres1>"+
                      "<sAdres2></sAdres2>"+
                      "<sSemt></sSemt>"+
                      "<sIl></sIl>"+
                      "<telefon></telefon>"+
                      "<sEMail>"+this.ContactForm.email+"</sEMail>"+
                      "<sVergiDairesi></sVergiDairesi>"+
                      "<sVergiNo></sVergiNo>"+
                      "<nAlisverisID>0</nAlisverisID>"+
                      "<lFisNo>0</lFisNo>"+
                      "<sFirma><![CDATA["+  sFirma + "]]></sFirma>"+
                      "<sModuller><![CDATA[<strong>"+this.sModuller+"</strong>]]></sModuller>"+
                      "<sOnayKodlari><![CDATA["+this.sOnayKodlari+"]]></sOnayKodlari>"+
                      "<sOdemeSekli>"+this.ContactForm.subject+"</sOdemeSekli>"+
                      "<sIp>"+ip+"</sIp>"+
                      "</mail_gonder>"+
                      "</soap12:Body>"+
                      "</soap12:Envelope>";
                      
                      //console.log(str2);
                      axios({method:'post',url:'https://www.barkodyazilimevi.com.tr/AuthToken.asmx',data:str2,headers: {'Content-Type': 'text/xml; charset=utf-8','Access-Control-Allow-Headers': 'Origin'}})
                      .then((response) => {
                          if (response.status==200){
                            console.log(response.statusText);
                            notify(this.$t('thanks'), "info", 5000);
                            this.sent=true;
                            this.ContactForm.name="";
                            this.ContactForm.email="";
                          }
                          else{
                                console.log(response); 
                          };
                        
                        event.preventDefault();
                        
                      })
                })
                }
                      );

               
            },
        }
}
</script>


